export default {
  //header
  'Services': "Услуги",
  'Expertise': "Экспертиза",
  'Industries': 'Отрасли',
  'Our team': 'Наша команда',
  'Our Projects': 'Наши проекты',



  ///Expertise
  'Who we are': 'Кто мы',

  'Who we are Text1': "JaiyqDev — глобальный технологический партнер, который лидирует в трансформации отраслей и создает долгосрочную ценность для бизнеса, людей и глобального сообщества.",
  'Who we are Text2': "Нам доверяют решение самых сложных задач и преодоление ограничений на пути к значимым инновациям в динамичной рыночной среде.",
  'Who we are Text3': "Опираясь на 20 лет опыта на рынке, люди JaiyqDev с их ориентацией на клиента и страстью к успеху объединяют инженеров, создателей и новаторов по всей Европе, Северной Америке и Ближнему Востоку.",

  'Engineers Text1': "Внутренние",
  'Engineers Text2': "разработчики",

  'Expertise/Countries Text1': "Страны, в которых",
  'Expertise/Countries Text2': "находятся клиенты",

  'Expertise/Experience Text1': "Лет",
  'Expertise/Experience Text2': "опыта",

  'Expertise/Senior Text1': "Сеньор",
  'Expertise/Senior Text2': "разработчики",

  'Expertise/Our missions Text1': "Наши миссии",
  'Expertise/Our missions Text2': "Мы воплощаем великие идеи с помощью",
  'Expertise/Our missions Text3': "цифровых технологий",




  ///Information
  "Information/Text1": "Умный комфорт во всех",
  "Information/Text2": "офисах JaiyqDev",
  "Information/Text3": "JaiyqDev — это глобальный технологический партнер, который способствует устойчивому успеху ведущих организаций и компаний из списка Fortune 500.",
  "Information/Text4": "Предоставляя ценность нашим партнерам и клиентам с помощью технологий, мы внушаем уверенность в том, что их цифровые инициативы будут успешными. Они доверяют нам решение самых сложных задач и преодоление ограничений на пути к значимым инновациям в динамичной рыночной среде.",



  ///CompanyStaff
  "CompanyStaff/Text1": "Познакомьтесь с нашей командой",



  ///OurProjects
  "OurProjects/Text1": "Наши проекты",



  ///Project
  "Project/Summary": "Описание:",
  "Project/Client": "Клиент",
  "Project/Country": "Страна",
  "Project/Industry": "Отрасль",
  "Project/Type of service": "Тип услуги",
  "Project/What we've challenged to do": "Что мы поставили перед собой",
  "Project/What we've done": "Что мы сделали",
  "Project/What we've delivered": "Что мы доставили",
  "Project/Stacks used": "Использованные технологии",
  "Project/Resources used": "Использованные ресурсы",
  "Project/delivered app for iOS": "приложение для iOS",
  "Project/delivered app for android": "приложение для Android",



  ///Footersec

  "Footersec/You find us": "Найдите нас",
  "Footersec/Visit": "Посетите",
  "Footersec/Oral kalasy, Eskalieva 179": "Город Уральск, Эскалиева 179",



  ///Projects

  // Проект 1
  "Projects/projectId1WhatOurClientDo": "Служба доставки товаров из зарубежных интернет-магазинов к вам домой",
  "Projects/projectId1Country": "США/Казахстан",
  "Projects/projectId1Industry": "Шопинг, доставка",
  "Projects/projectId1TypeOfService": "Аутсорс",
  "Projects/projectId1WhatChallengedToDoMainText": "Наша задача заключалась в создании приложения для iOS, Android и веб, в котором пользователь может:",
  "Projects/projectId1WhatChallengedToDoList1": "- создать посылку",
  "Projects/projectId1WhatChallengedToDoList2": "- проверить детали посылки, контрольные точки",
  "Projects/projectId1WhatChallengedToDoList3": "- пополнить баланс с помощью банковской карты, Apple Pay",
  "Projects/projectId1WhatDoneMainText": "Процесс был следующим:",
  "Projects/projectId1WhatDoneList1": "1. Анализ объема проекта, подготовка плана разработки",
  "Projects/projectId1WhatDoneList2": "2. Определение обязанностей участников команды",
  "Projects/projectId1WhatDoneList3": "3. Внедрение дизайна",
  "Projects/projectId1WhatDoneList4": "4. Запуск мультиплатформенного приложения",
  "Projects/projectId1WhatDeliveredMainText": "Проведение воркшопов, составление дорожной карты (2 недели). Разработка MVP (3,5 месяца). Сбор отзывов от первых клиентов, поставщиков и команды службы Shipper (2 месяца). Дальнейшее развитие продукта на основе собранных данных. Приложение простое в использовании и обеспечивает быструю, плавную работу как на мобильных устройствах, так и на планшетах. Благодаря нашей работе, пользователи Shipper могут искать необходимые посылки, видеть детали контрольных точек и пополнять баланс с помощью карты или Apple Pay.",
  "Projects/projectId1StacksUsed": "Разработка мобильных приложений, Веб-разработка, React Native, React, Redux-toolkit, REST API, Firebase, Push notifications, Deep linking, Оплата картой, Apple Pay, CloudPayments",
  "Projects/projectId1ResourcesUsed": "2 мобильных разработчика, 1 менеджер проекта, 1 тестировщик, 1 веб/мобильный дизайнер",
  "Projects/projectId1Duration": "7+ месяцев",

  // Проект 2
  "Projects/projectId2WhatOurClientDo": "Криптовалюта, трейдинг, социальная сеть для трейдеров",
  "Projects/projectId2Country": "США",
  "Projects/projectId2Industry": "Криптовалюта, трейдинг",
  "Projects/projectId2TypeOfService": "Аутстафф",
  "Projects/projectId2WhatChallengedToDoMainText": "Earnity уже имел полностью функциональное веб-приложение. В связи с изменениями на рынке и потребностями пользователей клиент стремился добавить мобильное приложение для платформ Android и iOS. Так как текущие пользователи были знакомы с веб-приложением, основной задачей проекта было предоставить те же функции и опыт в мобильной версии. Предлагаемое приложение должно быть быстрым, масштабируемым и эффективно интегрироваться с API, предоставленным клиентом. Клиент пришел к нам с готовым дизайном и функциональными требованиями, но не имел большого опыта в процессе разработки ПО.",
  "Projects/projectId2WhatDoneMainText": "Процесс был следующим:",
  "Projects/projectId2WhatDoneList1": "1. Анализ объема проекта, подготовка плана для разработки и дизайна",
  "Projects/projectId2WhatDoneList2": "2. Определение обязанностей участников команды",
  "Projects/projectId2WhatDoneList3": "3. Внедрение дизайна",
  "Projects/projectId2WhatDoneList4": "4. Начало процесса разработки",
  "Projects/projectId2WhatDeliveredMainText": "После запуска Earnity были внедрены следующие интересные функции:",
  "Projects/projectId2WhatDeliveredList1": "- проверка идентификации пользователя с использованием Jumio SDK",
  "Projects/projectId2WhatDeliveredList2": "- оплата токенов через платежную систему Stripe",
  "Projects/projectId2WhatDeliveredList3": "- социальная сеть, ленты активности и чаты через GetStream.io",
  "Projects/projectId2WhatDeliveredList4": "- push-уведомления",
  "Projects/projectId2StacksUsed": "Разработка мобильных приложений, React Native, React Sweet state, GetStream.io, Jumio SDK, Stripe SDK",
  "Projects/projectId2ResourcesUsed": "1 разработчик React Native",
  "Projects/projectId2Duration": "11+ месяцев",

  // Проект 3
  "Projects/projectId3WhatOurClientDo": "Приложение предназначено для беременных женщин и матерей детей младше одного года.",
  "Projects/projectId3Country": "Казахстан",
  "Projects/projectId3Industry": "Медицина",
  "Projects/projectId3TypeOfService": "Аутсорс",
  "Projects/projectId3WhatChallengedToDoMainText": "Наша задача заключалась в создании приложения для Android и iOS, в котором пользователь может:",
  "Projects/projectId3WhatChallengedToDoList1": "- общаться через онлайн-чат/видеозвонок с прикрепленным врачом из клиники",
  "Projects/projectId3WhatChallengedToDoList2": "- социальная сеть, где пользователь может делиться опытом и публиковать интересные новости",
  "Projects/projectId3WhatChallengedToDoList3": "- проходить медицинские тесты",
  "Projects/projectId3WhatDoneMainText": "Процесс был следующим:",
  "Projects/projectId3WhatDoneList1": "1. Анализ объема проекта, подготовка плана для разработки и дизайна",
  "Projects/projectId3WhatDoneList2": "2. Определение обязанностей участников команды",
  "Projects/projectId3WhatDoneList3": "3. Внедрение дизайна",
  "Projects/projectId3WhatDoneList4": "4. Начало процесса разработки",
  "Projects/projectId3WhatDeliveredMainText": "За восемь месяцев мы создали Supermom Academy — кросс-платформенное приложение, которое позволяет вызвать скорую помощь. Пользователь может общаться с врачом через чат или видеозвонок. Благодаря приложению, пользователь может читать посты, делиться ими, ставить лайки и комментировать.",
  "Projects/projectId3StacksUsed": "Разработка мобильных приложений, React Native",
  "Projects/projectId3ResourcesUsed": "1 мобильный разработчик, 1 тестировщик, 1 менеджер проекта, 1 backend-разработчик",
  "Projects/projectId3Duration": "8 месяцев",

  // Проект 4
  "Projects/projectId4WhatOurClientDo": "Решения для бизнеса: Онлайн-касса, QR-платежи, доставка до постаматов и т.д.",
  "Projects/projectId4Country": "Казахстан",
  "Projects/projectId4Industry": "Бизнес",
  "Projects/projectId4TypeOfService": "Аутстафф",
  "Projects/projectId4WhatChallengedToDoMainText": "Наша задача заключалась в создании приложения для Android и iOS, которое выполняет функции кассового аппарата. Бизнес может принимать платежи, возвращать деньги, принимать QR-платежи, печатать чеки через Bluetooth-принтер, просматривать историю платежей и т.д.",
  "Projects/projectId4WhatDeliveredMainText": "В результате у нас получилось мобильное кассовое приложение. Бизнес легко может принимать платежи, возвращать деньги при необходимости, печатать чеки через Bluetooth-принтер и генерировать отчеты.",
  "Projects/projectId4StacksUsed": "Разработка мобильных приложений с использованием React Native, Typescript, Redux Toolkit, REST API, Firebase, Push notifications, Deep linking",
  "Projects/projectId4ResourcesUsed": "1 разработчик React Native",
  "Projects/projectId4Duration": "18+ месяцев",

  // Проект 5
  "Projects/projectId5WhatOurClientDo": "Culdesac — это социальная сеть для фанатов спорта, созданная для того, чтобы вернуть голос болельщикам.",
  "Projects/projectId5Country": "США",
  "Projects/projectId5Industry": "Спорт",
  "Projects/projectId5TypeOfService": "Аутстафф",
  "Projects/projectId5WhatChallengedToDoMainText": "Основной задачей было создать приложение, похожее на Reddit, где пользователи могут публиковать посты о спортивных событиях, обсуждать другие посты, оставлять комментарии, соглашаться или не соглашаться с постами.",
  "Projects/projectId5WhatDeliveredMainText": "В итоге у нас получилось мобильное приложение для журналистов, бывших спортсменов или обычных фанатов. Пользователи могут лайкать, комментировать, соглашаться или не соглашаться с постами. Самые популярные посты отображаются в списке популярных.",
  "Projects/projectId5StacksUsed": "Разработка мобильных приложений с использованием React Native, Typescript, Redux Toolkit, REST API, Firebase, Push notifications, Deep linking",
  "Projects/projectId5ResourcesUsed": "1 разработчик React Native",
  "Projects/projectId5Duration": "5 месяцев",

  // Проект 6
  "Projects/projectId6WhatOurClientDo": "Высококурируемая программа привилегий, разработанная для улучшения жизни занятого руководителя.",
  "Projects/projectId6Country": "США",
  "Projects/projectId6Industry": "Бизнес",
  "Projects/projectId6TypeOfService": "Аутстафф",
  "Projects/projectId6WhatChallengedToDoMainText": "Задача заключалась в создании приложения для iOS/Android, в котором пользователи могут пользоваться различными привилегиями.",
  "Projects/projectId6WhatDeliveredMainText": "После запуска приложения пользователи EXEC могут получить доступ к повышенному уровню гостеприимства и специальным ценам через эксклюзивную коллекцию из сотен привилегий. EXEC помогает людям улучшить свою жизнь способами, которые ранее были недоступны.",
  "Projects/projectId6StacksUsed": "Разработка мобильного приложения с использованием React Native, Typescript, Redux Toolkit, GraphQL, Firebase, Push Notifications, Deep Linking",
  "Projects/projectId6ResourcesUsed": "1 разработчик React Native",
  "Projects/projectId6Duration": "6-8 месяцев",

  // Проект 7
  "Projects/projectId7WhatOurClientDo": "Роскошный бренд с системой членства, который разрабатывает, стилизует и поставляет одежду и аксессуары высочайшего качества для мужчин по всему миру.",
  "Projects/projectId7Country": "США",
  "Projects/projectId7Industry": "Дизайн одежды",
  "Projects/projectId7TypeOfService": "Аутстафф",
  "Projects/projectId7WhatChallengedToDoMainText": "Основной задачей приложения было реализовать анимированный дизайн, запрошенный клиентом. Также необходимо было уведомлять пользователя на каждом этапе доставки коллекции.",
  "Projects/projectId7WhatDeliveredMainText": "Результатом стало красивое кросс-платформенное приложение. Пользователи могут сохранять свои кредитные карты в приложении, выбирать основную карту и оплачивать членство.",
  "Projects/projectId7StacksUsed": "Разработка мобильного приложения с использованием React Native, Typescript, Redux Toolkit, REST API, Firebase, Push Notifications, Deep Linking",
  "Projects/projectId7ResourcesUsed": "1 разработчик React Native",
  "Projects/projectId7Duration": "8+ месяцев",
}